import { getLanguageFromLocale, Locales } from '@ratehub/base-ui';

import { GIC_TERMS } from '../definitions/GICTermsOptions';
import fetchGICs from './fetchGICs';

/**
 * Fetches the best GIC rates for all default terms and types for a given province and locale.
 *
 * @param {string} province - The province for which to fetch the rates.
 * @param {string} locale - The locale for which to fetch the rates.
 * @returns {Promise<{ rates: Object[], lastUpdatedDate: string }>} The rates and last updated date.
 */
async function fetchProductTableBestGICRatesDefaults(province, locale) {
    // generates best GIC rates by using fallbacks
    // this works because fallback rates are the same as best rates
    const products = [];
    TYPES.forEach(type => {
        GIC_TERMS.forEach(term => {
            products.push({
                requested: [ {} ],
                fallback: {
                    term,
                    type,
                },
            });
        });
    });

    const response = await fetchGICs({
        products,
        province,
        language: getLanguageFromLocale(locale ?? Locales.ENGLISH),
    });

    return {
        rates: response.data?.products,
        lastUpdatedDate: response.data?.lastUpdatedDate,
    };
}

const TYPES = [ 'non-registered', 'registered' ];


export default fetchProductTableBestGICRatesDefaults;
